import { useState, useEffect, useMemo } from 'react';
import { execSeatableSql } from './seatable.js';

function Footer() {
    const currentYear = new Date().getFullYear();
    const [locationsData, setLocationsData] = useState([]);
    const [socialdata, setSocialdata] = useState([]);
    const [ContactsData, setContactsData] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const sql = `SELECT * FROM Locations WHERE \`IsActive\` IS TRUE ORDER BY \`rank\``;
            const sql1 = `SELECT * FROM SocialLinks  WHERE \`IsActive\` IS TRUE ORDER BY \`rank\``;
            const sql2 = `SELECT * FROM Contacts  WHERE \`IsActive\` IS TRUE ORDER BY \`rank\``;

            try {
                const rows = await execSeatableSql(sql);
                setLocationsData(rows?.results || []);

                const socialdatarows = await execSeatableSql(sql1);
                setSocialdata(socialdatarows?.results || []);

                const conatctrows = await execSeatableSql(sql2);
                setContactsData(conatctrows?.results || [])
            } catch (err) { }
        }
        fetchData();
    }, []);


    const addressData = locationsData && locationsData.length > 0 ? locationsData.find(item => item.Name === "Address") : [];
    const contactData = ContactsData && ContactsData.length > 0 ? ContactsData.find(item => item.Name === "Contact Us") : [];

    return (
        <div className="mx-5 my-3 d-flex flex-column justify-content-around">
            <div className="my-3 d-flex flex-column justify-content-center align-items-center">
                <h1 className="my-3">Get In Touch</h1>
                <h3 className="mt-3">Let's build your AI-powered future together.</h3>
            </div>

            <div className="my-5 d-flex flex-column flex-md-row justify-content-start justify-content-md-around">
                <div>
                    <h3 className="text-accent">Where to Find Us</h3>
                    {locationsData.map((item, i) => (
                        <div key={i} className="location-block mb-3">
                            {item.details.split(/\n+/).map((line, idx) => (
                                <div key={idx}>{line}</div>  
                            ))}
                        </div>
                    ))}

                </div>

                {/* <div>
                    <h3 className="text-accent">Contact Us</h3>
    
                    <ul>
                        <li key={1}><a href="mailto:info@allteam.com"><span>info@allteam.com</span></a></li>
                        <li key={2}><a href="tel:+16466031779"><span>+1 646-603-1779</span></a></li>
                        <li key={3}>
                            <div className="d-flex flex-row">
                                <a href="tel:+19198887857">
                                    <span>+1 919-888-7857</span>
                                </a>
                                <a href="https://wa.me/+19198887857?text=Hello%20there!" target="_blank" rel="noreferrer" className="ms-2">
                                    <i className="bi bi-whatsapp"></i>
                                </a>
                            </div>
                        </li>
                        <li key={4}><a href="tel:+919916906403"><span>+91-99169-06403</span></a></li>
                        <li key={9}>
                            <div className="mt-3">
                            <i className="me-2 bi bi-linkedin"></i>
                            <i className="me-2 bi bi-facebook"></i>
                            <i className="me-2 bi bi-twitter-x"></i>
                            <i className="me-2 bi bi-instagram"></i>
                            <i className="bi bi-youtube"></i>
                            </div>
                        </li>
                    </ul>
                </div> */}
                <div>
                    <h3 className="text-accent">Contact Us</h3>
                    {ContactsData.map((item, i) => {
                        if (item.type === "email") {
                            return (
                                <div key={i}>
                                    <a href={`mailto:${item.details}`}>{item.details}</a>
                                </div>
                            );
                        }

                        if (item.type === "phone") {
                            return (
                                <div key={i} className="d-flex align-items-center gap-2">
                                    <a href={`tel:${item.details}`}>{item.details}</a>

                                    {/* WhatsApp for specific numbers */}
                                    {(item.IsWhatsApp === true || item.IsWhatsApp === "true" || item.IsWhatsApp === 1) && (
                                        <a
                                            href={`https://wa.me/${item.details.replace(/\D/g, "")}`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <i className="bi bi-whatsapp"></i>
                                        </a>
                                    )}
                                </div>
                            );
                        }

                        return null;
                    })}

                    <div className="d-flex align-items-center gap-3 mt-3">
                        {socialdata?.map((item, i) => {
                            const iconUrl = item.fnLink;

                            if (!iconUrl || iconUrl.includes('#VALUE')) return null;

                            return (
                                <a
                                    key={item._id || i}
                                    href={item.url || "#"}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src={iconUrl}
                                        alt={item.Name}
                                        style={{ width: "24px", height: "24px", objectFit: "contain" }}
                                        onError={(e) => {
                                            e.target.style.display = "none"; // hide broken images
                                        }}
                                    />
                                </a>
                            );
                        })}
                    </div>
                </div>

                <div className="footer-tagline-container">
                    <div className="footer-tagline">
                        GROWTH
                        <span>GROWTH</span>
                        <span>GROWTH</span>
                        <span>PROFIT</span>
                    </div>
                </div>
            </div>

            <div className="d-flex flex-row justify-content-center">
                <h6 className="text-secondary">{`© Allteam Outsourcing Pvt Ltd | All Rights Reserved | ${currentYear}`}</h6>
            </div>
        </div>
    )
}

export default Footer;